import React from "react";
import MainIntersectProvider from "../../MainIntersectProvider";
import { AcademicCapIcon } from "@heroicons/react/solid";

function Info() {
	return (
		<section className='container mx-auto px-5 py-20 xl:px-40'>
			<div className='text-center mb-20'>
				<MainIntersectProvider>
					<AcademicCapIcon className='w-10 inline-block mb-4' />
				</MainIntersectProvider>
				<h1 className='sm:text-3xl text-2xl font-medium title-font text-white mb-4'>
					About Me
				</h1>
			</div>
			<div className='grid grid-column-1 md:grid-cols-2 md:gap-5 items-center'>
				<p className='mb-8 leading-relaxed'>
					<span className='text-7xl text-gray-200'>I</span> am a software
					developer, majoring in computer science and fascinated by new
					technologies. I have experience working on projects based on full
					stack web development, data science and machine learning. I'm always
					open to learning new things that improve my skills.
				</p>
				<img
					className='select-none pointer-events-none rounded-lg'
					src='./projectImages/carbon.png'
					alt=''
				/>
			</div>
		</section>
	);
}

export default Info;
